'use client';

import { Badge } from '@wolfejs/ui/Badge';
import { Title } from '@wolfejs/ui/Title';
import type { UIColor } from '@wolfejs/ui/types/UI';
import { UIColors, UISizes } from '@wolfejs/ui/types/UI';
import React from 'react';

export type LandingCardProps = {
  badge?: string;
  badgeColor?: UIColor;
  text: string | React.ReactNode;
  footer?: React.ReactNode;
};

export const LandingCard = ({ badge, text, footer, badgeColor }: LandingCardProps) => {
  return (
    <div className="border-default-200 bg-default-50 dark:bg-default-800 flex flex-1 flex-col items-start justify-start gap-3 rounded-lg border p-4">
      <Badge size={UISizes.xs} color={badgeColor || UIColors.success} className="font-medium">
        {badge}
      </Badge>
      <Title as={'h2'} className="mb-0">
        {text}
      </Title>
      {footer && <div className="flex gap-2">{footer}</div>}
    </div>
  );
};
